import React from 'react';
import cn from 'classnames';
import * as MUI from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { styles } from './styles';
import { Props } from './types';
import ParentExpansion from '../../ParentExpansion';

export const GlobalCategory = withStyles(styles)(
  class GlobalCategory extends ParentExpansion<Props> {
    readonly globalCategory: React.RefObject<HTMLDivElement>;

    constructor(props) {
      super(props);
      this.globalCategory = React.createRef();
    }

    render() {
      const { className, classes } = this.props;
      const { expanded } = this.state;
      return (
        <MUI.ExpansionPanel
          ref={this.globalCategory} 
          className={cn(className, classes.globalCategory)} 
          expanded={expanded}>
          {this.boundChildren}
        </MUI.ExpansionPanel>
      );
    }
  })

export default GlobalCategory;

export * from './GlobalCategoryBody';
export * from './GlobalCategoryRow';
export * from './GlobalCategoryTitle';